var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavTesttypes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 3.33329H14.1667C16.0076 3.33329 17.5 4.82568 17.5 6.66663V15C17.5 16.8409 16.0076 18.3333 14.1667 18.3333H5.83333C3.99238 18.3333 2.5 16.8409 2.5 15V6.66663C2.5 4.82568 3.99238 3.33329 5.83333 3.33329H6.66667M13.3333 3.33329C13.3333 4.25377 12.5871 4.99996 11.6667 4.99996H8.33333C7.41286 4.99996 6.66667 4.25377 6.66667 3.33329M13.3333 3.33329C13.3333 2.41282 12.5871 1.66663 11.6667 1.66663H8.33333C7.41286 1.66663 6.66667 2.41282 6.66667 3.33329M10 8.33329H13.3333M10 11.6666H13.3333M10 15H13.3333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 8.33333C7.91667 8.79357 7.54357 9.16667 7.08333 9.16667C6.6231 9.16667 6.25 8.79357 6.25 8.33333C6.25 7.8731 6.6231 7.5 7.08333 7.5C7.54357 7.5 7.91667 7.8731 7.91667 8.33333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 11.6667C7.91667 12.1269 7.54357 12.5 7.08333 12.5C6.6231 12.5 6.25 12.1269 6.25 11.6667C6.25 11.2065 6.6231 10.8334 7.08333 10.8334C7.54357 10.8334 7.91667 11.2065 7.91667 11.6667Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 15C7.91667 15.4602 7.54357 15.8333 7.08333 15.8333C6.6231 15.8333 6.25 15.4602 6.25 15C6.25 14.5397 6.6231 14.1666 7.08333 14.1666C7.54357 14.1666 7.91667 14.5397 7.91667 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavTesttypes);
export default __webpack_public_path__ + "static/media/sidenav-testtypes.daa55908874cf08f3647b86ec2bfec73.svg";
export { ForwardRef as ReactComponent };